export const IEliteTokenStore = Symbol.for("IEliteTokenStore");

export interface IEliteTokenStore {
  token: string | undefined;
  loading: boolean;
  canGenerate: boolean;
  userAgentHeader: boolean;
  togglingUserAgentHeader: boolean;
  fetchToken(): Promise<void>;
  saveToken(token: string): Promise<void>;
  toggleUserAgentHeader(): Promise<void>;
}
